import { AxiosError } from 'axios';
import { useState } from 'react';

import { LookupConfigInterface } from '../../../models/dashboard/lookup/lookup-config';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { lookupConfigDataActions } from '../../../redux/slices/lookupConfigDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useLookupConfig = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onLookupConfigError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onLookupConfigSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<LookupConfigInterface>) => {
        dispatch(lookupConfigDataActions.setLookupConfig(data));
    };

    const LookupConfig = async () => {
        const url: HttpConfig = {
            url: `api/v1/configs/current`,
            method: 'get',
        };

        return request(url, onLookupConfigSuccess, setLoading, onLookupConfigError);
    };

    return { LookupConfig, loading };
};

export default useLookupConfig;
